import { Compass } from '@phosphor-icons/react';
import { Button } from '../ui/button';

export interface CampaignUnavailableProps {
  /** Navigate back to the caller app's campaigns list. */
  onGoToCampaigns: () => void;
}

/**
 * Full-page state shown when a campaign slug cannot be opened — either it
 * doesn't exist OR the signed-in user has no access to it. The backend
 * deliberately returns a single 404 for both cases (privacy: a brand can't
 * probe other orgs' campaigns), so we surface ONE combined, friendly message
 * rather than distinguishing the two.
 *
 * Routing is delegated via `onGoToCampaigns` so this stays router-agnostic and
 * reusable across the brand and admin apps.
 */
export function CampaignUnavailable({ onGoToCampaigns }: CampaignUnavailableProps) {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-card text-foreground">
      <Compass size={48} className="text-slate-300" />
      <h1 className="text-2xl font-semibold">Campaign not available</h1>
      <p className="max-w-md text-center text-body-sm-regular text-muted-foreground">
        This campaign doesn&apos;t exist, or you don&apos;t have access to it. It may belong to a
        different organization.
      </p>
      <Button variant="outline" onClick={onGoToCampaigns}>
        Go to campaigns
      </Button>
    </div>
  );
}
